import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import DefaultHeader from "@/components/Headers/DefaultHeader.vue";
import DefaultFooter from "@/components/Footers/DefaultFooter.vue";
import Slide from '@/layouts/default/profile/SlideProfile.vue'
import Social from '@/components/social/Social.vue'
import ManageNews from '@/layouts/default/profile/ManageNews.vue'
import ManageBuilding from '@/layouts/default/profile/ManageBuilding.vue'
import { useRoute } from "vue-router";
import { AppleOutlined, AndroidOutlined } from '@ant-design/icons-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultProfile',
  setup(__props) {

const route = useRoute();
const slideCollapsed = ref(false)

const onSlideCollapsedChange = (value: boolean) => {
	slideCollapsed.value = value
}
const activeKey = ref('1');
// onMounted(()=>{
// 	let ref = route.query.ref || '';
// 	if(ref != '') {
// 		commons.setLocalStorage(USER_REF, ref)
// 		login(ref)
// 	}
	
// })
// const login = async (ref: any) =>  {
// 		const dataRequest = {
//         userName: ref,
//         password: ref,
//       };
//       await apiPost(USER_V1_LOGIN, dataRequest).then((res) => {
//         let response: any = res;
//         if (response.data.statusCode == 200) {
//           let dataLogin = response.data.data;
//           checkUser(dataLogin);
//         }
//       });
// }

// const checkUser = (dataLogin: any) => {
//   commons.setUserInform(dataLogin);
//   commons.setCokiesUser(dataLogin);
// };

return (_ctx: any,_cache: any) => {
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_layout, {
      class: _normalizeClass(["layout-default layout-default-profile", [_unref(route).meta.layoutClass]]),
      id: "layout-default"
    }, {
      default: _withCtx(() => [
        _createVNode(DefaultHeader),
        _createVNode(_component_a_layout_content, null, {
          default: _withCtx(() => [
            _createVNode(ManageNews)
          ]),
          _: 1
        }),
        _createVNode(DefaultFooter),
        _createVNode(Social)
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}
}

})